import { useNavigate } from 'react-router-dom'

import { KNOWLEDGE_TABS } from '@/features/projects/layout/project-nav'
import { projectSectionPath } from '@/features/projects/project-routes'
import { TabButton, TabsList } from '@/shared/components/ui/tabs'

export function KnowledgeTabs({
  projectId,
  activeSection,
}: {
  projectId: string
  activeSection: string
}) {
  const navigate = useNavigate()

  return (
    <TabsList>
      {KNOWLEDGE_TABS.map((tab) => {
        const isActive = activeSection === tab.section

        return (
          <TabButton
            active={isActive}
            aria-current={isActive ? 'page' : undefined}
            key={tab.section}
            onClick={() => navigate(projectSectionPath(projectId, tab.section))}
          >
            {tab.label}
          </TabButton>
        )
      })}
    </TabsList>
  )
}
